import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import Preview from "../widgets/preview";

// Book preview
let previewElem = document.querySelector(".widget-preview");
if (previewElem) {
    window.Dibook.preview.widget = {
        open: bookId => {
            render(<Preview elem={previewElem} bookId={Number(bookId)} />, previewElem);
        },
        close: () => unmountComponentAtNode(previewElem)
    };
}
